import React, { useId, type ChangeEvent } from 'react'
import { Box, TextField, Typography, type SxProps, type Theme } from '@mui/material'
import { SECTION_DESCRIPTION_MAX_LENGTH } from '../../constant'

interface SectionDescriptionFieldProps {
  value: string
  onChange: (value: string) => void
  sx?: SxProps<Theme>
}

const SectionDescriptionField: React.FC<SectionDescriptionFieldProps> = ({ value, onChange, sx }) => {
  const countId = useId()
  const length = value.length
  const isOverLimit = length > SECTION_DESCRIPTION_MAX_LENGTH

  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    onChange(event.target.value.slice(0, SECTION_DESCRIPTION_MAX_LENGTH))
  }

  return (
    <Box sx={sx}>
      <TextField
        fullWidth
        placeholder="e.g. A simple description that captures the content of this section."
        value={value}
        onChange={handleChange}
        error={isOverLimit}
        inputProps={{
          maxLength: SECTION_DESCRIPTION_MAX_LENGTH,
          'aria-describedby': countId
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
        <Typography
          id={countId}
          variant="body2"
          sx={{
            color: isOverLimit ? 'error.main' : 'text.secondary',
            fontSize: '0.875rem'
          }}
        >
          {length}/{SECTION_DESCRIPTION_MAX_LENGTH}
        </Typography>
      </Box>
    </Box>
  )
}

export default SectionDescriptionField
